import { SafetyCheck } from '@mui/icons-material'
import { Box, TextField } from '@mui/material'
import { createFyaNotice } from 'api/services/automation/config'
import DialogWrapper from 'components/DialogWrapper'
// import FormDate from 'components/FormFields/FormDate'
import LoadingButton from 'components/LoadingButton'
import SafeTextField from 'components/SafeTextField'
import { snack } from 'components/toast'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { handleError } from 'utils/handleError'
let addFyaNotice = {
  din: "",
  issuedOn: null,
  responseDueDate: null,
  nameOfAssesse: "",
  description: "",
  pan: ""
}

interface fyaNotice {
  din: string;
  issuedOn: any;
  responseDueDate: any;
  nameOfAssesse: string;
  description: string;
  pan: string;
}

const CreateFyaNotice = ({ open, setOpen, state }) => {
  const queryClient = useQueryClient()
  const { control, handleSubmit, reset, register } = useForm<fyaNotice>({
    defaultValues: addFyaNotice,
    mode: "onChange"
  })

  const { mutate, isLoading } = useMutation(createFyaNotice, {
    onSuccess: () => {
      snack.success("Fya Notice Added")
      queryClient.invalidateQueries("e-proceeding")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })

  const onSubmit = async (item) => {
    if (item?.din?.trim().length < 5) {
      return snack.error("DIN is mandatory")
    }
    item.din = item?.din.trim()
    item.nameOfAssesse = item?.nameOfAssesse.trim()
    item.description = item?.description.trim()
    if (!item?.issuedOn) {
      return snack.error("Issued On is mandatory")
    }
    if (!item?.responseDueDate) {
      return snack.error("Response Due Date is mandatory")
    }

    const issuedOnDate = new Date(item.issuedOn);
    const responseDueDate = new Date(item.responseDueDate);

    if (issuedOnDate >= responseDueDate) {
      return snack.error("Response Due Date must be after Issued On date");
    }
    mutate({
      ...item,
      proceedingId: state?.id
    })
  }

  useEffect(() => {
    if (open) {
      reset({
        nameOfAssesse: state?.client?.autProfileDetails?.[0]?.name || "",
        pan: state?.client?.autProfileDetails?.[0]?.pan || "",
        issuedOn: null,
        responseDueDate: null
      })
    }
  }, [open])
  return (
    <DialogWrapper open={open} setOpen={setOpen} title='Create FYA Notice'>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <Box mt={1}>
          <TextField
            label="Name"
            fullWidth
            size='medium'
            value={state?.client?.autProfileDetails?.[0]?.name}
            disabled
          />
        </Box> */}
        <Box mt={1}>
          <TextField
            label="Proceeding Name"
            size='medium'
            value={state?.proceedingName || ""}
            fullWidth
            disabled
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="Notice Section"
            size='medium'
            value={state?.noticeName || ""}
            fullWidth
            disabled
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="Name Of Assesse"
            fullWidth
            size='medium'
            {...register(`nameOfAssesse` as const)}
          />
        </Box>

        <Box mt={1}>
          <TextField
            label="Assesse PAN"
            fullWidth
            size='medium'
            {...register(`pan` as const)}
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="DIN"
            fullWidth
            size='medium'
            required
            {...register(`din` as const)}
          />
        </Box>
        {/* <Box mt={1}>
          <FormDate
            name="issuedOn"
            required
            control={control}
            label="Issued On"
          />
        </Box>
        <Box mt={1}>
          <FormDate
            name="responseDueDate"
            required
            control={control}
            label="Response Due Date"
          />
        </Box> */}
        <Box mt={1}>
          <TextField
            label="Description"
            fullWidth
            size='medium'
            {...register(`description` as const)}
          />
        </Box>
        <Box mt={1}>
          <LoadingButton
            loading={isLoading}
            disabled={isLoading}
            loadingColor='white'
            type="submit"
            title='Submit'
            color='secondary'
          />
        </Box>
      </form>
    </DialogWrapper>
  )
}

export default CreateFyaNotice